export const pages = {
	'linkOutID': { id: 'linkOutID', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
